//Importación de Librerias
//---------------TemisCivil---------------
//Catalogos
import TiposPormocion from '../../../src/components/TemisCivil/Catalogos/TiposPromocion.vue'
import TiposMensajeria from '../../../src/components/TemisCivil/Catalogos/TiposMensajeria.vue'
import UsuariosEquitas from '../../../src/components/TemisCivil/Catalogos/UsuariosEquitas.vue'
import UsuariosDigitalizacion from '../../../src/components/TemisCivil/Catalogos/UsuariosDigitalizacion.vue'
import ZonasCiviles from '../../../src/components/TemisCivil/Catalogos/ZonasCiviles.vue'
import AreasRecepcion from '../../../src/components/TemisCivil/Catalogos/AreasRecepcion.vue'
import TiposDocumentoEnvio from '../../../src/components/TemisCivil/Catalogos/TiposDocumentoEnvio.vue'
import AreasPromocion from '../../../src/components/TemisCivil/Catalogos/AreasPromocion.vue'
import OrigenOficio from '../../../src/components/TemisCivil/Catalogos/OrigenOficioOtro.vue'
import TiposInstitucion from '../../../src/components/TemisCivil/Catalogos/TiposInstitucion.vue'
import Autoridades from '../../../src/components/TemisCivil/Catalogos/Autoridades.vue'
import Cargos from '../../../src/components/TemisCivil/Catalogos/Cargos.vue'
import Municipios from '../../../src/components/TemisCivil/Catalogos/Municipios.vue'

//Creamos y asignamos los datos necesarios de PJ
const temiscivil = [
  { Proviene: 'TemisCivil', Nombre: 'TiposPromocion', datos: TiposPormocion },
  { Proviene: 'TemisCivil', Nombre: 'TiposMensajeria', datos: TiposMensajeria },
  { Proviene: 'TemisCivil', Nombre: 'UsuariosEquitas', datos: UsuariosEquitas },
  { Proviene: 'TemisCivil', Nombre: 'UsuariosDigitalizacion', datos: UsuariosDigitalizacion },
  { Proviene: 'TemisCivil', Nombre: 'ZonasCiviles', datos: ZonasCiviles },
  { Proviene: 'TemisCivil', Nombre: 'AreasRecepcion', datos: AreasRecepcion },
  { Proviene: 'TemisCivil', Nombre: 'TiposDocumentoEnvio', datos: TiposDocumentoEnvio },
  { Proviene: 'TemisCivil', Nombre: 'AreasPromocion', datos: AreasPromocion },
  { Proviene: 'TemisCivil', Nombre: 'OrigenOficio', datos: OrigenOficio },
  { Proviene: 'TemisCivil', Nombre: 'TiposInstitucion', datos: TiposInstitucion },
  { Proviene: 'TemisCivil', Nombre: 'Autoridades', datos: Autoridades },
  { Proviene: 'TemisCivil', Nombre: 'Cargos', datos: Cargos },
  { Proviene: 'TemisCivil', Nombre: 'Municipios', datos: Municipios },
]

//Exportamos los datos de TemisCivil
export default temiscivil;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/temiscivil.js
// module id = null
// module chunks = 